import * as Icons from '@mui/icons-material';

export default function Icon({ name, className }: { name: keyof typeof Icons, className?: string }) {
  const IconComponent = Icons[name];
  return (
    <div className={ `flex w-6 h-6 ${ className }` }>
      <IconComponent
        sx={ { width: '100%', height: '100%' } }
      />
    </div>
  );
}
